import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { consumeTheme } from '../../utils/theme';
var Divider = (function (_super) {
    __extends(Divider, _super);
    function Divider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, dashed = _b.dashed, children = _b.children, orientation = _b.orientation, textPosition = _b.textPosition;
            var containsText = children && orientation === 'horizontal';
            var classes = classNames(prefixCls, className, prefixCls + "-" + orientation + (dashed ? '-dashed' : ''), (_a = {},
                _a[prefixCls + "-with-text"] = containsText,
                _a));
            var textClasses = classNames(prefixCls + "-text", [prefixCls + "-text-" + textPosition]);
            return (h("div", { className: classes, style: style }, containsText ? h("span", { className: textClasses }, children) : null));
        };
        return _this;
    }
    Divider.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Divider;
}(React.Component));
export default Divider;
Divider.defaultProps = {
    prefixCls: 'dui-m-divider',
    dashed: false,
    orientation: 'horizontal',
    textPosition: 'center'
};
Divider.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    dashed: PropTypes.bool,
    orientation: PropTypes.string,
    textPosition: PropTypes.string
};
